import isItemView from 'owa-mail-store/lib/utils/isItemView';
import removeConversationData from './removeConversationData';
import removeItemData from './removeItemData';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';

export default function removeRowData(rowId: string, tableView: TableView): void {
    if (isItemView(tableView)) {
        removeItemData(rowId, tableView);
    } else {
        removeConversationData(rowId, tableView);
    }
}
